import { TextField } from "@mui/material";
import { useEthers } from "@usedapp/core";
import React, { useContext, useRef, useState } from "react";
import {
	ScrollPosition,
	trackWindowScroll,
} from "react-lazy-load-image-component";
import { useHistory } from "react-router-dom";
import { backendURI, changeUsernameBackend } from "../../api/backend";
import { useUsername } from "../../api/username";
import { PostsContext } from "../../App";
import { useShowAlert, useShowLoading } from "../../hooks";
import styles from "../Profile/Profile.module.css";
import ProfilePicture from "../ProfilePicture/ProfilePicture";
import PostStub from "./PostStub/PostStub";

type ProfileT = {
	walletAddress: string;
	author: string;
	scrollPosition: ScrollPosition;
};

const Profile: React.FC<ProfileT> = ({
	walletAddress,
	author,
	scrollPosition,
}) => {
	const { posts } = useContext(PostsContext);

	const { deactivate, library, account } = useEthers();
	const defaultUsername = useUsername(account);
	const [currentUsername, setCurrentUsername] = useState(defaultUsername);

	const usernameField = useRef<HTMLDivElement>(null);

	const showAlert = useShowAlert();
	const showLoading = useShowLoading();

	function logOutHandler() {
		deactivate();
		history.goBack();
	}

	let history = useHistory();

	async function usernameChangeHandler() {
		if (currentUsername === defaultUsername) {
			document.getElementById("inputHack")?.focus();
			return;
		}

		if (!library) {
			showAlert("You are not logged in.", "error");
			return;
		}

		if (!currentUsername) {
			showAlert("The username can't be empty!", "error");
			return;
		}

		if (currentUsername.length < 4) {
			showAlert("The username can't be shorter than 4 characters.", "error");
			return;
		}

		if (currentUsername.length > 17) {
			showAlert("The username can't be longer than 17 characters.", "error");
			return;
		}

		showLoading(true);

		try {
			const toSign = "New username: " + currentUsername;
			const response = await changeUsernameBackend(
				currentUsername,
				await library!.getSigner().signMessage(toSign)
			);

			if (!response.ok) {
				showAlert(await response.text(), "error");
			} else {
				showAlert("Username changed!", "info");
				// force the browser to update its cache
				fetch(`${backendURI}/username/${account}`, { cache: "reload" });
			}
		} catch (e) {
			showAlert("There was an error.", "error");
		}

		showLoading(false);
	}

	return (
		<div className={styles.container}>
			<div className={styles.profilePicture}>
				<ProfilePicture address={author} height="8rem" />
			</div>
			<div className={styles.usernameEditBox}>
				<TextField
					ref={usernameField}
					variant="standard"
					placeholder="Input your nickname here"
					value={currentUsername}
					onChange={(e) => setCurrentUsername(e.target.value)}
					InputProps={{ className: styles.username, id: "inputHack" }}
					sx={{ width: "16.5rem" }}
				/>
				<button
					className={styles.usernameEditButton}
					onClick={usernameChangeHandler}
				>
					Edit
				</button>
				{/*<Popup
					trigger={
						
					}
					modal
				>
					<div className={styles.popup}>
						<input
							type="text"
							className={styles.popupInput}
							placeholder="Your beautiful name"
							maxLength={32}
							onChange={(e) => setUsername(e.target.value)}
						/>
						<button className={styles.popupTip}>OK</button>
					</div>
				</Popup>*/}
			</div>
			<div className={styles.walletAddress}>{walletAddress}</div>
			<div>
				{posts
					?.filter(
						(post) => post.author?.toLowerCase() === author.toLowerCase()
					)
					.map((post, idx) => {
						return (
							<PostStub
								key={idx}
								post={post}
								className={styles.postStub}
								scrollPosition={scrollPosition}
							/>
						);
					})}
			</div>
			<div>
				<button
					className={[styles.logOutButton, styles.animation].join(" ")}
					style={{ color: "white" }}
					onClick={logOutHandler}
				>
					Log Out
				</button>
			</div>
		</div>
	);
};

export default trackWindowScroll(Profile);
